import { Box, Typography, Chip, Grid, Paper } from '@mui/material';
import { useAppStore } from '../../hooks/useAppStore';

export default function ReviewStep() {
  const {
    selectedWords,
    selectedLayout,
    selectedShape,
    selectedSpacing,
  } = useAppStore();

  const groupedWords = Object.entries(selectedWords || {});

  return (
    <Box>
        <Typography variant="body2" color="text.secondary">
        -Remember love comes first, no matter how confusing or how long it takes for you pet to learn
        -This soundboard plan is a guideline and there will be change for sure. Your pet may need words you didn't anticipate, or things you thought would be useful turns out to not be used. Remember to review it once in a while and make neccessary updates
        -Pet buttons are not replacements for other forms of communications. The more ways we can communicate with our pets the better
        -Many pets will surprise their humans with unintended use of the words. Keep an openmind and develop a communication that belongs to your family.
        -use this as a STARTING POINT, and customize it for your needs. Such as putting words you know will be commonly used in an accessible place
      </Typography>
      <Paper
        elevation={3}
        sx={{
          p: 3,
          mb: 4,
          backgroundColor: 'var(--wizard-box-bg)',
          borderRadius: 'var(--wizard-box-radius)',
        }}
      >
        <Typography
          variant="h6"
          fontWeight={700}
          sx={{ fontFamily: 'var(--font-primary)', mb: 2 }}
        >
          Layout Selection
        </Typography>



        <Typography variant="body1" sx={{ mb: 1 }}>
          <strong>Shape:</strong> {selectedShape || '—'}
        </Typography>
        <Typography variant="body1">
          <strong>Layout:</strong> {selectedLayout || '—'}
        </Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          <strong>Spacing:</strong> {selectedSpacing || '—'}
        </Typography>
      </Paper>

      <Typography
        variant="h6"
        fontWeight={700}
        sx={{
          fontFamily: 'var(--font-primary)',
          mb: 2,
        }}
      >
        Selected Words
      </Typography>

      {groupedWords.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No words selected yet.
        </Typography>
      ) : (
        <Grid container spacing={3}>
          {groupedWords.map(([category, wordArray]) => (
            <Grid item xs={12} md={6} key={category}>
              <Typography
                variant="subtitle1"
                fontWeight={600}
                sx={{ mb: 1, color: 'var(--category-text-color)' }}
              >
                {category}
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {wordArray.map((word) => (
                  <Chip
                    key={word}
                    label={word}
                    variant="outlined"
                    sx={{
                      fontSize: '0.875rem',
                      fontWeight: 500,
                      fontFamily: 'var(--font-primary)',
                    }}
                  />
                ))}
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}